import React from 'react';
import { Table, TableHead, TableRow, TableCell, TableBody, Button } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

const SavedFeaturesDnDTable = ({ reorderedFeatures, onDragEnd, onEdit, onDelete }) => (
  <DragDropContext onDragEnd={onDragEnd}>
    <Droppable droppableId="saved-features-droppable">
      {(provided) => (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>FR_ID</TableCell>
              <TableCell>Module</TableCell>
              <TableCell>Feature</TableCell>
              <TableCell>Task Description/Attribute</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {reorderedFeatures.map((f, idx) => (
              <Draggable key={f.id} draggableId={`saved-feature-${f.id}`} index={idx}>
                {(dragProvided, dragSnapshot) => (
                  <TableRow
                    ref={dragProvided.innerRef}
                    {...dragProvided.draggableProps}
                    style={{ ...dragProvided.draggableProps.style, background: dragSnapshot.isDragging ? '#e3f2fd' : undefined }}
                  >
                    <TableCell {...dragProvided.dragHandleProps} style={{ cursor: 'grab' }}>{f.fr_id}</TableCell>
                    <TableCell>{f.name}</TableCell>
                    <TableCell>{f.feature}</TableCell>
                    <TableCell>{f.description}</TableCell>
                    <TableCell>
                      <Button size="small" onClick={() => onEdit(f)}>Edit</Button>
                      <Button size="small" color="error" onClick={() => onDelete(f.id)}>Delete</Button>
                    </TableCell>
                  </TableRow>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </TableBody>
        </Table>
      )}
    </Droppable>
  </DragDropContext>
);

export default SavedFeaturesDnDTable; 